import styled from "styled-components";
import { Link } from "react-router-dom";

export const SectionWalletInfo = styled("div")`
  background: white;
  padding: 20px 10px;
`;
export const ContainerWalletHeader = styled("div")`
  color: var(--blue-color-dark);
`;
export const WalletHeader = styled("h4")``;
export const ContainerWalletInfo = styled("div")`
  box-shadow: var(--box-shadow2);
  border-radius: var(--border-radius-1);
  padding: 10px;
`;
export const ContainerPriceInfo = styled("div")`
  padding: 10px 0;
  border-bottom: ${(props) =>
    props.withBorder && "1px dashed var(--blue-color-dark)"};
`;
export const ContainerPriceIcon = styled("span")`
  color: var(--primary-color);
  margin: 0 5px;
`;
export const ContainerPriceContent = styled("p")`
  color: var(--blue-color-dark);
  margin: 0;
`;

export const PriceContainer = styled("span")`
  font-weight: bolder;
`;

export const WithdrawButton = styled(Link)`
  color: var(--success-color);
  background: white;
  border: 1px solid var(--blue-color-dark);
  border-radius: var(--border-radius-1);
  padding: 3px 5px;
  margin: 0 5px;
`;
